/**
 * Do not edit directly
 * Generated on Tue, 12 Nov 2024 16:54:15 GMT
 */

export const assetFontNunitosansBlack = "assets/fonts/NunitoSans-Black.ttf";
export const assetFontNunitosansBlackitalic = "assets/fonts/NunitoSans-BlackItalic.ttf";
export const assetFontNunitosansBold = "assets/fonts/NunitoSans-Bold.ttf";
export const assetFontNunitosansBolditalic = "assets/fonts/NunitoSans-BoldItalic.ttf";
export const assetFontNunitosansExtrabold = "assets/fonts/NunitoSans-ExtraBold.ttf";
export const assetFontNunitosansExtrabolditalic = "assets/fonts/NunitoSans-ExtraBoldItalic.ttf";
export const assetFontNunitosansExtralight = "assets/fonts/NunitoSans-ExtraLight.ttf";
export const assetFontNunitosansExtralightitalic = "assets/fonts/NunitoSans-ExtraLightItalic.ttf";
export const assetFontNunitosansLight = "assets/fonts/NunitoSans-Light.ttf";
export const assetFontNunitosansLightitalic = "assets/fonts/NunitoSans-LightItalic.ttf";
export const assetFontNunitosansRegular = "assets/fonts/NunitoSans-Regular.ttf";
export const assetFontNunitosansSemibold = "assets/fonts/NunitoSans-SemiBold.ttf";
export const assetFontNunitosansSemibolditalic = "assets/fonts/NunitoSans-SemiBoldItalic.ttf";
export const colorBaseGrayscaleBlack = "#2b2b2b";
export const colorBaseGrayscaleOffBlack = "#2b2b2b";
export const colorBaseGrayscaleGray = "#616161";
export const colorBaseGrayscaleShadeGray = "#616161";
export const colorBaseGrayscaleLightGray = "#9d9d9d";
export const colorBaseGrayscaleOffWhite = "#f7f7f7";
export const colorBaseGrayscaleWhite = "#ffffff";
export const colorBaseBlackPrimary = "#2b2b2b";
export const colorBaseBlackDark = "#000000";
export const colorBaseBlackLight = "#2b2b2b";
export const colorBaseWhitePrimary = "#ffffff";
export const colorBaseWhiteDark = "#dddddd";
export const colorBaseGreyPrimary = "#616161";
export const colorBaseGreyDark = "#616161";
export const colorBaseGreyLight = "#9d9d9d";
export const colorBaseBluePrimary = "#2c6f84";
export const colorBaseBlueDark = "#1a434f";
export const colorBaseBlueLight = "#d5e2e6";
export const colorBaseGreenPrimary = "#00d589";
export const colorBaseGreenDark = "#0d875c";
export const colorBaseGreenLight = "#ccf7e7";
export const colorBaseTealPrimary = "#00bfb9";
export const colorBaseTealDark = "#00737f";
export const colorBaseTealLight = "#ccf2f1";
export const colorBasePurplePrimary = "#5942cd";
export const colorBasePurpleDark = "#35287b";
export const colorBasePurpleLight = "#e1ddf6";
export const colorBaseRedPrimary = "#ff5200";
export const colorBaseRedDark = "#993100";
export const colorBaseRedLight = "#ffdccc";
export const colorBaseOrangePrimary = "#ffa200";
export const colorBaseOrangeDark = "#996100";
export const colorBaseOrangeLight = "#ffeccc";
export const colorBaseYellowPrimary = "#f9f871";
export const colorBaseYellowDark = "#7d7c39";
export const colorBaseYellowLight = "#fefee3";
export const colorBaseSandPrimary = "#bdb6aa";
export const colorBaseSandDark = "#706f61";
export const colorBaseSandLight = "#f7f4ee";
export const colorPaletteGrayscale0 = "#ffffff";
export const colorPaletteGrayscale50 = "#f7f7f7";
export const colorPaletteGrayscale100 = "#dddddd";
export const colorPaletteGrayscale300 = "#9d9d9d";
export const colorPaletteGrayscale500 = "#616161";
export const colorPaletteGrayscale700 = "#2b2b2b";
export const colorPaletteGrayscaleBlack = "#000000";
export const colorPaletteBlue50 = "#dde8eb";
export const colorPaletteBlue100 = "#d5e2e6";
export const colorPaletteBlue200 = "#abc5ce";
export const colorPaletteBlue300 = "#80a9b5";
export const colorPaletteBlue400 = "#568c9d";
export const colorPaletteBlue500 = "#2c6f84";
export const colorPaletteBlue600 = "#23596a";
export const colorPaletteBlue700 = "#1a434f";
export const colorPaletteGreen50 = "#d6f9ec";
export const colorPaletteGreen100 = "#ccf7e7";
export const colorPaletteGreen200 = "#99eed0";
export const colorPaletteGreen300 = "#66e6b8";
export const colorPaletteGreen400 = "#33dda1";
export const colorPaletteGreen500 = "#00d589";
export const colorPaletteGreen600 = "#00c07b";
export const colorPaletteGreen700 = "#0d875c";
export const colorPaletteTeal50 = "#e0f7f7";
export const colorPaletteTeal100 = "#ccf2f1";
export const colorPaletteTeal200 = "#99e5e3";
export const colorPaletteTeal300 = "#66d9d5";
export const colorPaletteTeal400 = "#33ccc7";
export const colorPaletteTeal500 = "#00bfb9";
export const colorPaletteTeal600 = "#009994";
export const colorPaletteTeal700 = "#00737f";
export const colorPalettePurple50 = "#e7e4f8";
export const colorPalettePurple100 = "#e1ddf6";
export const colorPalettePurple200 = "#cdc6f0";
export const colorPalettePurple300 = "#aca1e6";
export const colorPalettePurple400 = "#7a68d7";
export const colorPalettePurple500 = "#5942cd";
export const colorPalettePurple600 = "#4735a4";
export const colorPalettePurple700 = "#35287b";
export const colorPaletteRed100 = "#ffdccc";
export const colorPaletteRed200 = "#ffba99";
export const colorPaletteRed300 = "#ff9766";
export const colorPaletteRed400 = "#ff7533";
export const colorPaletteRed500 = "#ff5200";
export const colorPaletteRed600 = "#cc4200";
export const colorPaletteRed700 = "#993100";
export const colorPaletteOrange100 = "#ffeccc";
export const colorPaletteOrange200 = "#ffda99";
export const colorPaletteOrange300 = "#ffc766";
export const colorPaletteOrange400 = "#ffb533";
export const colorPaletteOrange500 = "#ffa200";
export const colorPaletteOrange600 = "#cc8200";
export const colorPaletteOrange700 = "#996100";
export const colorPaletteYellow100 = "#fefee3";
export const colorPaletteYellow200 = "#fdfcc6";
export const colorPaletteYellow300 = "#fbfbaa";
export const colorPaletteYellow400 = "#faf98d";
export const colorPaletteYellow500 = "#f9f871";
export const colorPaletteYellow600 = "#bbba55";
export const colorPaletteYellow700 = "#7d7c39";
export const colorPaletteSand50 = "#fbf9f6";
export const colorPaletteSand100 = "#f7f4ee";
export const colorPaletteSand200 = "#f4eee5";
export const colorPaletteSand300 = "#f0e9dd";
export const colorPaletteSand400 = "#ece3d4";
export const colorPaletteSand500 = "#bdb6aa";
export const colorPaletteSand600 = "#8e887f";
export const colorPaletteSand700 = "#706f61";
export const colorSeverityMonitorDark = "#706f61";
export const colorSeverityMonitorLight = "#f4eee5";
export const colorSeverityRepairDark = "#996100";
export const colorSeverityRepairLight = "#ffeccc";
export const colorSeveritySafetyDark = "#993100";
export const colorSeveritySafetyLight = "#ffdccc";
export const colorSeverityOtherDark = "#5c5c4e";
export const colorSeverityOtherLight = "#f7f4ee";
export const colorTagsMonitorBackground = "#f4eee5";
export const colorTagsMonitorIcon = "#706f61";
export const colorTagsMonitorText = "#706f61";
export const colorTagsRepairBackground = "#ffeccc";
export const colorTagsRepairIcon = "#996100";
export const colorTagsRepairText = "#996100";
export const colorTagsSafetyBackground = "#ffdccc";
export const colorTagsSafetyIcon = "#993100";
export const colorTagsSafetyText = "#993100";
export const colorTagsDeficiencyBackground = "#35287b";
export const colorTagsDeficiencyIcon = "#dddddd";
export const colorTagsDeficiencyText = "#dddddd";
export const colorTagsLimitationBackground = "#fbfbaa";
export const colorTagsLimitationIcon = "#7d7c39";
export const colorTagsLimitationText = "#7d7c39";
export const colorTagsNotPresentBackground = "#dddddd";
export const colorTagsNotPresentIcon = "#2b2b2b";
export const colorTagsNotPresentText = "#2b2b2b";
export const colorTagsFixedBackground = "#0d875c";
export const colorTagsFixedIcon = "#dddddd";
export const colorTagsFixedText = "#dddddd";
export const colorTagsFlagBackground = "#f7f7f7";
export const colorTagsFlagIcon = "#ffa200";
export const colorTagsFlagText = "#2b2b2b";
export const colorTagsOtherBackground = "#ccf2f1";
export const colorTagsOtherIcon = "#00737f";
export const colorTagsOtherText = "#00737f";
export const fontFamilyBase = "Nunito Sans";
export const sizeFontXSmall = "12px";
export const sizeFontSmall = "14px";
export const sizeFontMedium = "16px";
export const sizeFontLarge = "18px";
export const sizeFontXLarge = "20px";
export const sizeFontBase = "16px";
export const sizeFontDisplayH1 = "40px";
export const sizeFontDisplayH2 = "36px";
export const sizeFontDisplayH3 = "32px";
export const sizeFontDisplayH4 = "24px";
export const sizeFontTextLarge = "20px";
export const sizeFontTextMedium = "18px";
export const sizeFontTextBody = "16px";
export const sizeFontTextButton = "16px";
export const sizeFontTextXSmall = "14px";
export const sizeFontTextUnderline = "14px";
export const sizeFontTextXxSmall = "12px";
export const sizeFontTextOverline = "12px";